export default {
  productCountAlign: (align: string | null) => ({
    display: 'flex',
    whiteSpace: 'nowrap',
    justifyContent: align !== null ? align : 'flex-end',
    alignItems: 'center',
    transform: 'translateY(3px)'
  })
};